import React from 'react';

const SizeFilter = ({
  sizes = [],
  selectedSizes = [],
  setSelectedSizes,
  exclude = [], // z.B. ["Onesize"]
  idPrefix = '', // z.B. "hut_"
}) => {
  const handleChange = (size) => {
    setSelectedSizes((prev) =>
      prev.includes(size) ? prev.filter((s) => s !== size) : [...prev, size]
    );
  };

  const filteredSizes = sizes.filter((s) => !exclude.includes(s));

  return (
    <div className="d-flex flex-wrap justify-content-center">
      {filteredSizes.map((size) => (
        <React.Fragment key={size}>
          <input
            type="checkbox"
            className="btn-check"
            id={`${idPrefix}${size}`}
            name={size}
            checked={selectedSizes.includes(size)}
            onChange={() => handleChange(size)}
          />
          <label htmlFor={`${idPrefix}${size}`} className="btn-filterSize">
            {size}
          </label>
        </React.Fragment>
      ))}
    </div>
  );
};

export default SizeFilter;
